import { useEffect, useRef, useState } from "react";
import Service from "../../Service/http";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { FcDownload } from "react-icons/fc";
import * as xlsx from "xlsx";
import { BuildCSV } from "../../Utils/UtilityFunctions";

function User() {

  const inputRef = useRef(null);

  let [loading, SetLoading] = useState(false);
  let [data, SetData] = useState([]);
  const service = new Service();

  const HandleSubmit = () => {
    if (Object.keys(data).length === 0) {
      toast.error("Please choose a file");
      return;
    }
    SetLoading(true);
    if (data.length > 0) {
      const body = {
        data: data,
      };
      service
        .post("api/pre/create/users", { allUsers: body })
        .then((json) => {
          SetLoading(false);
          const date = new Date();
          BuildCSV(json.data, ["EMAIL","COLLEGEID","NAME","ROLE","DEPARTMENT","COLLEGE","CRAWLING_APPROVED","PHONENUMBER","BATCH","CODECHEF","CODEFORCES","HACKERRANK","HACKEREARTH","INTERVIEWBIT","LEETCODE","MENTORPICK","GEEKSFORGEEKS","SPOJ","UVA","VJUDGE","SCHOOLGPA","INTERGPA", "STATUS", "ERROR"], `UsersStatusSheet-${date.getDay()}-${date.getMonth()}-${date.getFullYear()}-${date.getHours()}-${date.getMinutes()}-${date.getSeconds()}`);
          toast.success("Users Created Successfully");
          inputRef.current.value = "";
          SetData([])
        })
        .catch((error) => {
          SetLoading(false);
          toast.error(error);
        });
    } else {
      toast.error("Please upload a file");
      SetLoading(false);
      return;
    }
  };

  const handleFileUpload = (e) => {
    try {
      e.preventDefault();
      if (e && e.target && e.target.files && e.target.files[0]) {
        SetLoading(true);
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = xlsx.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const options = {
            raw: false,
          };
          const json = xlsx.utils.sheet_to_json(worksheet, options);
          SetData(json);
        };
        reader.readAsArrayBuffer(e.target.files[0]);
      } else {
        SetLoading(false);
        toast.error("Please choose a file");
        SetData([])

      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if(data) {
      if(loading) toast.success("File Uploaded Successfully");      
      SetLoading(false);
    } else {
      SetLoading(false);
    }
  }, [data])

  return (
    <>
      {(
        <div
          className="card"
          style={{ marginTop: "5%", marginLeft: "2%", marginRight: "2%" }}
        >
          <h1
            className="text-center card-title text-primary"
            style={{ margin: "2%" }}
          >
            Pre-Create / Update-User
          </h1>
          <div className="mx-5">
            <h1>Important Note</h1>
            <p>Below are the important details to consider:</p>
            <ul>
              <li>
                EMAIL is a MANDATORY field. If the email is not found in the
                database, a new user will be created.
              </li>
              <li>
                NAME must be included with the EMAIL during the pre-creation of
                the user.
              </li>
              <li>
                ROLE can be one amongst ['admin', 'student', 'college',
                'trainer', 'mentor'], with the default being 'student'.
              </li>
              <li>
                DEPARTMENT can be one amongst ['CSE','ECE','EEE','MECH','IT','CVL',
                 'AIM', 'CSC', 'CSD', 'CSM', 'CSO', 'CST', 'OTH' ], with the default being 'CSE'.
              </li>
              <li>
                CRAWLING_APPROVED can only have BOOLEAN values ['TRUE' /
                'FALSE'].
              </li>
              <li>
                BATCH can have only one value, and please ensure that the BATCH
                already exists in the database.
              </li>
            </ul>
          </div>

          <div>
            <div className="container text-center card-body">
              <div className="row row-cols-1">
                <div className="col">
                  <div>
                    <Link
                      className="float-start mb-2"
                      to="/files/SampleUserUploadSheetCpTracker.xlsx"
                      target="_blank"
                      download
                    >
                      <FcDownload /> Download Sample
                    </Link>
                    <div className=" my-2">
                      <input
                        className="form-control"
                        type="file"
                        placeholder="Upload Inter GPA for Users"
                        accept=".csv,.xlsx,.xls"
                        onChange={(e) => {
                          handleFileUpload(e);
                        }}
                        ref={inputRef}
                      />
                    </div>
                    <button
                      disabled={loading}
                      onClick={() => {
                        HandleSubmit();
                      }}
                      className={loading || data.length === 0 ? "btn btn-secondary float-end" : "btn btn-success float-end"}
                    >
                      {loading ? "Uploading ... " : "Submit"}
                      
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default User;
